// extracted by mini-css-extract-plugin
export default {"button":"button_button__0On-O","primary":"button_primary__ZBQkr","uniq":"button_uniq__UQ8mE","dark":"button_dark__2ywQA","gray":"button_gray__TzpHE"};